import React, { useState } from "react";

const Getintouch = () => {

  const [formData, setFormData] = useState({
    "your-name": "",
    "your-email": "",
    "your-message": "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  // input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    const form = new FormData();

    form.append("_wpcf7", "6");
    form.append("_wpcf7_version", "5.8");
    form.append("_wpcf7_locale", "en_US");
    form.append("_wpcf7_unit_tag", `wpcf7-f6-${Date.now()}`);

    form.append("your-name", formData["your-name"]);
    form.append("your-email", formData["your-email"]);
    form.append("your-message", formData["your-message"]);

    try {
      const res = await fetch(
        "https://codebuddys.in/wp-json/contact-form-7/v1/contact-forms/6/feedback",
        {
          method: "POST",
          body: form,
        }
      );

      const data = await res.json();
      console.log(data);

      if (data.status === "mail_sent") {
        setResponseMsg("✅ Message sent successfully!");
        setFormData({
          "your-name": "",
          "your-email": "",
          "your-message": "",
        });
      } else {
        setResponseMsg("❌ " + data.message);
      }

    } catch (err) {
      console.error(err);
      setResponseMsg("❌ Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <section>
      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-info">
          <h3 className="contact-title">Start the Conversation</h3>
          <p className="contact-subtitle">
            Drop us a message - our team will be <br /> in touch soon!
          </p>

          <div className="contact-details">
            <div className="detail-item">
              <i className="fas fa-phone detail-icon"></i>
              <span className="detail-text">+91 9737252452</span>
            </div>

            <div className="detail-item">
              <i className="fas fa-envelope detail-icon"></i>
              <span className="detail-text">info@codebuddys.in</span>
            </div>

            <div className="detail-item">
              <i className="fas fa-map-marker-alt detail-icon"></i>
              <span className="detail-text">Rajkot, Gujarat, India</span>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="contact-div">
          <div className="contact-form">

            <form onSubmit={handleSubmit}>

              <div className="form-group">
                <label className="form-label">Name:</label>
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  name="your-name"
                  placeholder="Your Name"
                  value={formData["your-name"]}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email:</label>
                <i className="fas fa-envelope"></i>
                <input
                  type="email"
                  name="your-email"
                  placeholder="Enter Email"
                  value={formData["your-email"]}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Message:</label>
                <i className="fa-solid fa-message"></i>
                <textarea
                  rows="3"
                  name="your-message"
                  placeholder="Your Message"
                  value={formData["your-message"]}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Sending..." : "Submit"}
              </button>

              {responseMsg && (
                <p
                  style={{
                    marginTop: "10px",
                    color: responseMsg.includes("✅") ? "green" : "red",
                    fontWeight: "600"
                  }}
                >
                  {responseMsg}
                </p>
              )}
            </form>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Getintouch;